/**
 * PLP Filter modal + Sort By bottom sheet
 * Filter pills → full-page modal; Sort pill → bottom sheet (closes on select).
 */
(function () {
  const COLOUR_MAP = {
    black: '#111111',
    white: '#f5f5f5',
    grey: '#9e9e9e',
    gray: '#9e9e9e',
    blue: '#3b82f6',
    green: '#22c55e',
    red: '#ef4444',
    orange: '#f97316',
    brown: '#92400e',
    beige: '#e8d9c5',
    gold: '#d4af37',
    yellow: '#eab308',
    pink: '#ec4899',
    purple: '#a855f7',
    multicolor: 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
  };

  function paintFallbackSwatches(root) {
    (root || document)
      .querySelectorAll('.plp-filter-modal__swatch-color--fallback[data-swatch-label]')
      .forEach((el) => {
        if (el.style.backgroundImage || el.style.backgroundColor) return;
        const key = (el.getAttribute('data-swatch-label') || '').toLowerCase().trim();
        const mapped = COLOUR_MAP[key] || COLOUR_MAP[key.split(/\s+/)[0]];
        if (!mapped) {
          el.style.backgroundColor = '#d4d4d4';
          return;
        }
        if (mapped.indexOf('gradient') !== -1) el.style.backgroundImage = mapped;
        else el.style.backgroundColor = mapped;
      });
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('plp-overlay-open', lock);
    document.body.classList.toggle('plp-overlay-open', lock);
  }

  function getSortBy() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('sort_by')) return params.get('sort_by');
    const select = document.getElementById('SortBy') || document.getElementById('SortBy-mobile');
    return select ? select.value : '';
  }

  function applySearchParams(searchParams) {
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.filterData = [];
      FacetFiltersForm.renderPage(searchParams, null, true);
      return;
    }
    const url = searchParams ? `${window.location.pathname}?${searchParams}` : window.location.pathname;
    window.location.href = url;
  }

  function buildFilterParams(modal) {
    const params = new URLSearchParams();
    const sortBy = getSortBy();
    if (sortBy) params.set('sort_by', sortBy);

    modal.querySelectorAll('[data-plp-filter-input]:checked:not(:disabled)').forEach((input) => {
      params.append(input.name, input.value);
    });

    return params.toString();
  }

  function buildClearParams() {
    const params = new URLSearchParams();
    const sortBy = getSortBy();
    if (sortBy) params.set('sort_by', sortBy);
    return params.toString();
  }

  function setActiveSection(modal, param) {
    if (!param) {
      const first = modal.querySelector('[data-plp-filter-section]');
      param = first ? first.getAttribute('data-plp-filter-section') : null;
    }
    if (!param) return;

    modal.querySelectorAll('[data-plp-filter-section]').forEach((btn) => {
      const active = btn.getAttribute('data-plp-filter-section') === param;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    modal.querySelectorAll('[data-plp-filter-panel]').forEach((panel) => {
      const active = panel.getAttribute('data-plp-filter-panel') === param;
      panel.classList.toggle('is-active', active);
      if (active) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  }

  function openFilterModal(param) {
    closeSortSheet();
    const modal = document.querySelector('[data-plp-filter-modal]');
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    setActiveSection(modal, param);
    paintFallbackSwatches(modal);
    lockScroll(true);
  }

  function closeFilterModal() {
    const modal = document.querySelector('[data-plp-filter-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[data-plp-sort-sheet].is-open')) lockScroll(false);
  }

  function openSortSheet() {
    closeFilterModal();
    const sheet = document.querySelector('[data-plp-sort-sheet]');
    if (!sheet) return;
    const current = getSortBy();
    sheet.querySelectorAll('[data-plp-sort-option]').forEach((radio) => {
      const selected = radio.value === current;
    radio.checked = selected;
      const opt = radio.closest('.plp-sort-sheet__option');
      if (opt) opt.classList.toggle('is-selected', selected);
    });
    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    sheet.classList.add('is-open');
    lockScroll(true);
  }

  function closeSortSheet() {
    const sheet = document.querySelector('[data-plp-sort-sheet]');
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.hidden = true;
    sheet.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[data-plp-filter-modal].is-open')) lockScroll(false);
  }

  function onDocumentClick(event) {
    const filterOpen = event.target.closest('[data-plp-open="filter"]');
    if (filterOpen) {
      event.preventDefault();
      openFilterModal(filterOpen.getAttribute('data-plp-param'));
      return;
    }

    const sortOpen = event.target.closest('[data-plp-open="sort"]');
    if (sortOpen) {
      event.preventDefault();
      openSortSheet();
      return;
    }

    if (event.target.closest('[data-plp-filter-close]')) {
      event.preventDefault();
      closeFilterModal();
      return;
    }

    if (event.target.closest('[data-plp-sort-close]')) {
      event.preventDefault();
      closeSortSheet();
      return;
    }

    const navItem = event.target.closest('[data-plp-filter-section]');
    if (navItem) {
      event.preventDefault();
      const modal = navItem.closest('[data-plp-filter-modal]');
      if (modal) setActiveSection(modal, navItem.getAttribute('data-plp-filter-section'));
      return;
    }

    if (event.target.closest('[data-plp-filter-apply]')) {
      event.preventDefault();
      const modal = event.target.closest('[data-plp-filter-modal]');
      if (!modal) return;
      applySearchParams(buildFilterParams(modal));
      closeFilterModal();
      return;
    }

    if (event.target.closest('[data-plp-filter-clear]')) {
      event.preventDefault();
      const modal = event.target.closest('[data-plp-filter-modal]');
      if (modal) {
        modal.querySelectorAll('[data-plp-filter-input]').forEach((input) => {
          input.checked = false;
        });
      }
      applySearchParams(buildClearParams());
      closeFilterModal();
    }
  }

  function onChange(event) {
    const sortOption = event.target.closest('[data-plp-sort-option]');
    if (!sortOption) return;

    const sheet = sortOption.closest('[data-plp-sort-sheet]');
    if (!sheet) return;
    sheet.querySelectorAll('.plp-sort-sheet__option').forEach((el) => el.classList.remove('is-selected'));
    const selectedLabel = sortOption.closest('.plp-sort-sheet__option');
    if (selectedLabel) selectedLabel.classList.add('is-selected');

    const params = new URLSearchParams(window.location.search);
    // Keep existing filter params; only change sort_by
    params.set('sort_by', sortOption.value);

    // Also sync hidden Dawn selects if present
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      select.value = sortOption.value;
    });

    closeSortSheet();
    applySearchParams(params.toString());
  }

  function onKeydown(event) {
    if (event.key !== 'Escape') return;
    if (document.querySelector('[data-plp-sort-sheet].is-open')) {
      closeSortSheet();
      return;
    }
    if (document.querySelector('[data-plp-filter-modal].is-open')) closeFilterModal();
  }

  function init() {
    paintFallbackSwatches(document);
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('change', onChange);
    document.addEventListener('keydown', onKeydown);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
